import { IAppState } from '../../redux';
import { EServiceType } from '../../redux/reducers';
import { selectActiveService } from '../publishTerms';

export function selectIsAuctionBetEnabled(state: IAppState): boolean {
  const {
    auction: { isEnabled },
  } = state;

  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  const { incompatibleServices } = selectedService;

  const isAuctionCompatible = !incompatibleServices.includes(EServiceType.auction);

  return isEnabled && isAuctionCompatible;
}
